import { useContext, useMemo } from "react";
import { LocalizationContext } from "../../../core/localization/Localization";
import { Column } from "material-table";
import { OrderIndData, OrderIndListData } from "../,,/../../../data/trading/orderIndicative/types";
import { renderOrderPrice, renderClient, TurnocateText } from "../orders/columRenderers";
import React from "react";
import { DisplayBoolNumber } from "../../components/common/DisplayBoolNumber";
import { Status } from "../../../data/models";
import { renderOrderIndSide } from "./columRenderers";

export function useOrderIDColumns() {
  const { getString, getFormatedNumberString } = React.useContext(LocalizationContext);
  return useMemo(
    () => [
      {
        title: getString("orderIndTime"),
        render: order =>
          new Date(order.creTime).toLocaleDateString("sr-RS", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          }),
        cellStyle: {
          maxWidth: "100px",
          minWidth: "100px",
          width: "100px",
          paddingRight: 0,
        },
        headerStyle: {
          maxWidth: "100px",
          minWidth: "100px",
          width: "100px",
          paddingRight: 0,
        },
      },
      {
        title: getString("orderSide"),
        //        render: renderOrderIndSide,
        field: "side",

        width: 50,
        cellStyle: {
          width: 50,
          maxWidth: 50,
          whiteSpace: "nowrap",
        },
      },
  /*    {
        title: getString("bankCode"),
        field: "productCode",
        width: 100,
        cellStyle: {
          width: 100,
          whiteSpace: "nowrap",
        },
      },  */
      {
        title: getString("orderProduct"),
        field: "productName",
        width: 150,
        cellStyle: {
          width: 150,
          whiteSpace: "nowrap",
        },
      },
      {
        title: getString("orderPrice"),
        field: "price",
        width: 200,
        cellStyle: {
          width: 200,
          whiteSpace: "nowrap",
        },
      },
      {
        title: getString("orderQty"),
        render: order => `${getFormatedNumberString(order.qty)} ${order.unit}`,
        sorting: false,
        cellStyle: {
          whiteSpace: "nowrap",
          textAlign: "end",
          paddingRight: "10px",
        },
        headerStyle: {
          whiteSpace: "nowrap",
          textAlign: "end",
          paddingRight: "10px",
        },
      },
      {
        title: getString("orderIndDescr"),
        field: "description",
      },
      {
        title: getString("orderIndComment"),
        field: "comment",
      },
      {
        title: getString("orderIndParity"),
        field: "parity",
      },
      {
        title: getString("empStatus"),
        render: orderInd => <DisplayBoolNumber value={orderInd.status} thrutyValue={Status.Active} />,
        customSort: (a, b) => a.status - b.status,
        width: 60,
        cellStyle: {
          width: 60,
          maxWidth: 60,
          minWidth: 60,
        },
        headerStyle: {
          width: 60,
          maxWidth: 60,
          minWidth: 60,
        },
      },
      {
        title: getString("orderbrokName"),
        field: "employeeName",
        width: 100,
        cellStyle: {
          width: 100,
          whiteSpace: "nowrap",
        },
      },
    ],
    [getString]
  ) as Column<OrderIndListData>[];
}
